export const THEME_AVERAGE = 'average'
export const THEME_HIGH = 'high'
export const THEME_LOW = 'low'
export const THEME_NEUTRAL = 'neutral'
export const THEME_VHIGH = 'vhigh'

const FACTOR_SCORE_TRESHOLDS = [0.3, 0.7, 0.9]

const INTERVIEW_SCORE_TRESHOLDS = [0.4, 0.75, 0.9]

const getTreshholds = (score, treshholds) => {
  const roundedScore = score == null ? null : Math.round(score * 100) / 100

  const [low, medium, high] = treshholds

  if (roundedScore == null) return THEME_NEUTRAL

  if (roundedScore <= low) return THEME_LOW

  if (roundedScore > low && roundedScore < medium) return THEME_AVERAGE

  if (roundedScore >= medium && roundedScore < high) return THEME_HIGH

  return THEME_VHIGH
}

export const getNormalizedScore =
  (range = 5) =>
  v =>
    v == null ? v : Math.round(1 + (range - 1) * v)

export const setNormalizedScore =
  (range = 5) =>
  v =>
    v == null ? v : (v - 1) / (range - 1)

export const getFactorScoreTreshholds = score =>
  getTreshholds(score, FACTOR_SCORE_TRESHOLDS)

export const getInterviewScoreTreshholds = score =>
  getTreshholds(score, INTERVIEW_SCORE_TRESHOLDS)
